export const RiskLevels = {
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
};

export const RiskScoreType = {
  INHERENT: "inherent",
  RESIDUAL: "residual",
};

export const TabName = {
  REGISTER: "register",
  ASSESSMENT: "assessment",
};

export const RiskAssessmentStatusTitle = {
  COMPLETED: "Completed",
  DRAFT: "Draft",
  DISCARDED: "Discarded",
};

export const TreatmentStatus = {
  ACCEPTED: "Accepted",
  TREATED: "Treated",
};
